module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"Trailer anschauen","flags":["TRACK"],"track":"Watch Trailer"}}